import axios from "axios";
import {Toast} from "vant";

// 创建axios实例
const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ?'/': process.env.VUE_APP_BASE_API , // api 的 base_url
    timeout: 60000,
});
// request拦截器
instance.interceptors.request.use(
    (config) => {
       config.headers['Content-Type'] = 'application/json'

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);
// response 拦截器
instance.interceptors.response.use(
    (config) => {
        const {data} = config;
        console.log(data,1)
        if (typeof data=='string') {
            return data;
        } else if (data.status == 200) {
            // console.log(data);
            
            return data.body;
        } else{
            if(data.status=='600' ||data.status=='601'||data.status=='635'||data.status=='640'|| data.message=='The order has completed ！'){
                return data;
            }else{
                // 把返回的数据去掉一层data属性
                return Promise.reject(data);
            }
                
        }
    },
    (err) => {
        // if (err.response && err.response.status === 401) {
        //   // token 失效了。跳转到登陆页
        //   return router.push("/login");
        // }
        return Promise.reject(err);
    }
);
export default instance;
